import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import AlertBox from "../components/AlertBox"; // استدعاء الكومبوننت بتاعك

export default function Contact() {
    const { t } = useTranslation();
    const [msg, setMsg] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        // هنا مستقبلاً هتبعت البيانات للـ API
        setMsg(t("contact_success"));
        e.target.reset(); // تفريغ الفورم
    };

    return (
        <div className="container py-5 mb-5">
            <div className="text-center mb-5">
                <h1 className="fw-bold text-primary"><i className="bi bi-envelope-paper me-2"></i>{t("contact_page_title")}</h1>
            </div>

            <div className="row g-5">
                {/* كروت معلومات التواصل */}
                <div className="col-lg-5">
                    <div className="card border-0 shadow-sm p-4 h-100 bg-primary text-white" style={{ background: "linear-gradient(135deg, #0d6efd 0%, #0dcaf0 100%)" }}>
                        <h4 className="fw-bold mb-4">{t("footer_about_title")}</h4>
                        <p className="mb-4 opacity-75">{t("footer_about_desc")}</p>
                        
                        <div className="d-flex align-items-center mb-4">
                            <div className="bg-white text-primary rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: "50px", height: "50px" }}>
                                <i className="bi bi-geo-alt fs-4"></i>
                            </div>
                            <div>
                                <h6 className="mb-0 fw-bold">العنوان</h6>
                                <small className="opacity-75">{t("footer_contact_address")}</small>
                            </div>
                        </div>

                        <div className="d-flex align-items-center mb-4">
                            <div className="bg-white text-primary rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: "50px", height: "50px" }}>
                                <i className="bi bi-telephone fs-4"></i>
                            </div>
                            <div>
                                <h6 className="mb-0 fw-bold">رقم الهاتف</h6>
                                <small className="opacity-75" dir="ltr">+20 100 000 0000</small>
                            </div>
                        </div>

                        <div className="d-flex align-items-center">
                            <div className="bg-white text-primary rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: "50px", height: "50px" }}>
                                <i className="bi bi-envelope fs-4"></i>
                            </div>
                            <div>
                                <h6 className="mb-0 fw-bold">البريد الإلكتروني</h6>
                                <small className="opacity-75">info@wageh.store</small>
                            </div>
                        </div>
                    </div>
                </div>

                {/* فورم التواصل */}
                <div className="col-lg-7">
                    <div className="card border-0 shadow-sm p-4 h-100">
                        <h4 className="fw-bold mb-4">{t("contact_form_title")}</h4>
                        <AlertBox type="success" message={msg} onClose={() => setMsg("")} />
                        
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label className="form-label fw-bold">{t("contact_name")}</label>
                                <input type="text" className="form-control form-control-lg bg-light border-0" required />
                            </div>
                            <div className="mb-3">
                                <label className="form-label fw-bold">{t("contact_email")}</label>
                                <input type="email" className="form-control form-control-lg bg-light border-0" required />
                            </div>
                            <div className="mb-4">
                                <label className="form-label fw-bold">{t("contact_message")}</label>
                                <textarea className="form-control form-control-lg bg-light border-0" rows="5" required></textarea>
                            </div>
                            <button type="submit" className="btn btn-primary btn-lg w-100 fw-bold shadow-sm">
                                <i className="bi bi-send me-2"></i>{t("contact_send")}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}